import { Alert, Button, Modal, Progress } from 'antd';
import { DownloadOutlined, ExportOutlined } from '@ant-design/icons';
import useExportTask from '../../hooks/useExportTask';

export default function FinanceExportButton({ exportApi, query, disabled, text = '导出 Excel' }) {
  const { visible, task, submitting, start, close, download } = useExportTask();
  const running = task?.status === 0 || task?.status === 1;

  return (
    <>
      <Button
        icon={<ExportOutlined />}
        loading={submitting}
        disabled={disabled}
        onClick={() => start(exportApi, query)}
      >
        {text}
      </Button>
      <Modal
        open={visible}
        title="导出任务"
        onCancel={close}
        footer={
          task?.status === 2
            ? [
                <Button key="close" onClick={close}>
                  关闭
                </Button>,
                <Button key="download" type="primary" icon={<DownloadOutlined />} onClick={download}>
                  下载 Excel
                </Button>,
              ]
            : [
                <Button key="close" onClick={close} disabled={running}>
                  关闭
                </Button>,
              ]
        }
      >
        <Progress
          percent={task?.progress || 0}
          status={task?.status === 3 ? 'exception' : task?.status === 2 ? 'success' : 'active'}
        />
        {running && <div style={{ marginTop: 12 }}>后台正在生成 Excel，请稍候...</div>}
        {task?.status === 2 && (
          <div style={{ marginTop: 12 }}>
            文件已生成，共 {task.totalRows || 0} 行，点击下方按钮下载。
          </div>
        )}
        {task?.status === 3 && (
          <Alert style={{ marginTop: 12 }} type="error" showIcon message={task.errorMsg || '导出失败'} />
        )}
      </Modal>
    </>
  );
}
